<mat-card style="border-color: #5775a8;">

  <mat-card-header>

    <div class="flex flex-col rounded-lg w-full">
      <div *ngIf="panelParent == 'business'" class="flex flex-col rounded-lg w-full">
        <span style="font-size: smaller;">
          This page contains information related to the complaint. Information on this page can only be updated by OHA.
        </span>
        <div class="flex flex-row rounded-lg w-full"
          style="background-color: #d4bc8e;align-items: center;padding: 15px;">
          <div class="flex flex-col w-full">
            <span style="color: #5f4006;">
              You cannot edit citations in this view. Click on links to complaints to view and edit citations for that
              complaint.
            </span>
            <span>
              *Note: <b>Annual Exempt Business Inspections</b> can be edited in this view by OHA.
            </span>
          </div>
        </div>
        <br />
      </div>
      <div class="flex flex-row rounded-lg w-full" style="background-color: #5775a8;align-items: center;">
        <div class="flex w-full">
          <span *ngIf="panelParent == 'complaint'" style="color: white;padding: 20px;">
            <!-- <mat-icon style="color: white;">settings</mat-icon> -->
            Citations for this business:
          </span>
          <span *ngIf="panelParent == 'business'" style="color: white;padding: 20px;">
            <!-- <mat-icon style="color: white;">settings</mat-icon> -->
            Citations for this business:
          </span>
        </div>

        <div *ngIf="isAdmin && panelParent == 'complaint'" class="flex flex-col" style="padding-right: 20px;">
          <button mat-raised-button (click)="add()" class="m-8 container" style="background: #7ABDF3;">
            <mat-icon>add</mat-icon> Add
          </button>
        </div>
      </div>

    </div>

  </mat-card-header>

  <mat-card-content>
    <br />
    <mat-card>
      <div class="flex flex-col" style="overflow-x:auto">
        <div class="flex flex-row">

          <table mat-table [dataSource]="dataSource" multiTemplateDataRows matSort fxFlex="100" #TableSort="matSort"
            class="mat-elevation-z8">

            <ng-container matColumnDef="id">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Citation ID</th>
              <td mat-cell *matCellDef="let citation">{{citation.id}}</td>
            </ng-container>
            <ng-container matColumnDef="complaintId">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Complaint ID</th>
              <td mat-cell *matCellDef="let citation">
                <span *ngIf="citation.complaintId != null && citation.complaintId > 0">{{citation.complaintId}}</span>
                <a *ngIf="citation.complaintId == null || citation.complaintId == 0" target="_blank"
                  (click)="gotoComplaint(citation.complaintId)">
                  {{citation.complaintId}}
                </a>
              </td>
            </ng-container>
            <ng-container matColumnDef="citationWarranted">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Citation Warranted</th>
              <td mat-cell *matCellDef="let citation">{{citation.citationWarranted?'Yes':'No'}}</td>
            </ng-container>
            <ng-container matColumnDef="finalOrderIssued">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Final Order</th>
              <td mat-cell *matCellDef="let citation">{{citation.finalOrderIssued?'Yes':'No'}}</td>
            </ng-container>
            <ng-container matColumnDef="settlementAgreement">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Settlement Reached</th>
              <td mat-cell *matCellDef="let citation">{{citation.settlementAgreement?'Yes':'No'}}</td>
            </ng-container>
            <ng-container matColumnDef="action">
              <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
              <td mat-cell *matCellDef="let citation">
                <a *ngIf="isAdmin" (click)="editCitation(citation)"><mat-icon>edit</mat-icon></a>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="expansion-element-row"></tr>
          </table>
        </div>
        <!-- <mat-paginator [pageSizeOptions]="[5, 10]" #TablePaginator="matPaginator" showFirstLastButtons></mat-paginator> -->
      </div>
    </mat-card>
    <br />

  </mat-card-content>

</mat-card>